module.exports = __webpack_public_path__ + "img/17.ca3e10db.jpg";